import { render, staticRenderFns } from "./unshippedDetail.vue?vue&type=template&id=b7fa8a82&scoped=true"
import script from "./unshippedDetail.vue?vue&type=script&lang=js"
export * from "./unshippedDetail.vue?vue&type=script&lang=js"
import style0 from "./unshippedDetail.vue?vue&type=style&index=0&id=b7fa8a82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7fa8a82",
  null
  
)

export default component.exports